
import { isEmpty } from '@/utils/tool.util';
import { EllipsisOutlined } from '@ant-design/icons-vue'
import { defineComponent, toRef } from 'vue';
import LevelItem from './LevelItem.vue'

export default defineComponent({
  name: 'MultiLevel',
  components: {
    EllipsisOutlined,
    LevelItem
  },
  props: {
    list: {
      type: Array,
      default: () => []
    }, // 数据列表
    showOperation: {
      type: Boolean,
      default: false
    }
  },
  setup (props, { emit, expose }) {
    const thisList = toRef(props, 'list')

    function deleteFirst () {
      thisList.value.splice(0, 1)
    }

    return {
      thisList,
      isEmpty,
      deleteFirst
    }
  }
})
